// src/lib/home.js
import { db } from '../firebase'
import {
  collection,
  getDocs,
  query,
  orderBy,
  limit,
  where,          // ✅ ajouté
} from 'firebase/firestore'
import { fetchProductsPage } from './products'

const toHttps = (u) =>
  typeof u === 'string'
    ? u.startsWith('http://')
      ? u.replace('http://', 'https://')
      : u
    : ''

// ✅ Sliders hero (homeBanners)
export async function fetchHomeBanners(max = 6) {
  try {
    const q = query(
      collection(db, 'homeBanners'),
      orderBy('order', 'asc'),
      limit(max)
    )
    const snap = await getDocs(q)

    return snap.docs.map((d) => {
      const data = d.data() || {}
      return {
        id: d.id,
        title: data.title || '',
        subtitle: data.subtitle || '',
        imageUrl: toHttps(data.imageUrl || data.image || ''),
        href: data.href || '/catalog',
        order: data.order ?? 1,
        active: data.active !== false, // par défaut true si absent
        backgroundColor: data.backgroundColor || null,
      }
    })
  } catch (e) {
    console.error('fetchHomeBanners error:', e)
    return []
  }
}

export async function fetchFeaturedProducts({ pageSize = 8 } = {}) {
  // on part de la première page sans filtre, et on tronque à pageSize
  const { items } = await fetchProductsPage({ pageSize })
  return items
}

export async function fetchPromoLinks(max = 8) {
  try {
    const q = query(
      collection(db, 'promoLinks'),
      orderBy('order', 'asc'),
      limit(max)
    )
    const snap = await getDocs(q)
    return snap.docs.map((d) => {
      const data = d.data() || {}
      return {
        id: d.id,
        title: data.title || '',
        subtitle: data.subtitle || '',
        logo: toHttps(data.logo || ''),
        href: data.href || '#',
        theme: data.theme || 'light', // 'light' | 'dark' (pour style carte éventuel)
        order: data.order ?? 0,
      }
    })
  } catch {
    return []
  }
}
